import type { RegionId } from "../types";

export const DEFAULT_REGIONS: Array<{ id: RegionId; label: string }> = [
  { id: "AMER", label: "AMER (AMERICAS)" },
  { id: "EMEA", label: "EMEA (EUROPE, MIDDLE EAST, AFRICA)" },
  { id: "APAC", label: "APAC (ASIA-PACIFIC)" },
];

export function countryMatchesSearch(
  country: { code: string; name: string },
  search: string
): boolean {
  const normalized = search.trim().toLowerCase();
  if (!normalized) return true;
  return (
    country.name.toLowerCase().includes(normalized) ||
    country.code.toLowerCase().includes(normalized)
  );
}

type TaxonomyState = { id?: string | null; name?: string | null };

export function buildUniqueSortedStates(
  statesData: TaxonomyState[] | null | undefined
): Array<{ id: string; name: string }> {
  if (!statesData || statesData.length === 0) return [];
  const seen = new Set<string>();
  return statesData
    .filter((s) => {
      if (!s.id || !s.name) return false;
      if (seen.has(s.id)) return false;
      seen.add(s.id);
      return true;
    })
    .map((s) => ({ id: s.id!, name: s.name! }))
    .sort((a, b) => a.name.localeCompare(b.name));
}

export function filterStatesBySearch(
  states: Array<{ id: string; name: string }>,
  search: string
): Array<{ id: string; name: string }> {
  const normalized = search.trim().toLowerCase();
  if (!normalized) return states;
  return states.filter((s) => s.name.toLowerCase().includes(normalized));
}

export function toggleIncludedValue(
  included: string[],
  excluded: string[],
  value: string,
  checked: boolean
): { included: string[]; excluded: string[] } {
  return {
    included: checked
      ? [...included, value]
      : included.filter((v) => v !== value),
    excluded: excluded.filter((v) => v !== value),
  };
}

export function toggleExcludedValue(
  included: string[],
  excluded: string[],
  value: string,
  checked: boolean
): { included: string[]; excluded: string[] } {
  const nextExcluded = checked
    ? [...excluded, value]
    : excluded.filter((v) => v !== value);

  return {
    excluded: nextExcluded,
    included: included.filter((v) => v !== value),
  };
}
